import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import addAnalytics from "./assets/config/setup/analytics";
import addTuiWrapper from "./assets/config/setup/tui-wrapper";
import { TranslationsProvider } from "./features/translation";
import { loadSettings, settings } from "./assets/config/settings";

const start = async () => {
  try {
    const hostname = window.location.hostname;
    await loadSettings(hostname);

    const match = /tui\.(se|dk|fi|no)/.exec(hostname);
    const market = match ? match[1] : "se";

    addAnalytics(market, "Information", "Group travel quote request");
    await addTuiWrapper(market);

    return market;
  } catch (error) {
    console.error("App initialization failed:", error);
    return "se";
  }
};

const Root = () => {
  const [market, setMarket] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const market = await start();
      setMarket(market);
    };

    fetchData();
  }, []);

  if (market === null) {
    return <div></div>;
  }

  return (
    <TranslationsProvider language={settings.language}>
      <App path="/*" market={market} />
    </TranslationsProvider>
  );
};

const root = document.getElementById("root");
if (root) {
  const reactRoot = ReactDOM.createRoot(root);
  reactRoot.render(<Root />);
}
